<template>
  <!-- 宽高需要以设计稿倍数设置 -->
  <!-- https://developers.facebook.com/community/threads/281007613843950/ -->
  <div
    class="fb-page"
    id="fb-page"
    :data-href="link"
    data-show-posts="true"
    data-small-header="true"
    :data-width="width"
    :data-height="height ? height : 70"
    data-adapt-container-width="true"
    data-hide-cover="false"
    data-show-facepile="true"
  >
    <blockquote
      cite=""
      target="_top"
      class="fb-xfbml-parse-ignore"
    >
      <a
        :href="link"
        target="_top"
      >{{text}}</a>
    </blockquote>
  </div>
</template>

<script setup>
import { defineProps, ref, watch } from "vue";

const props = defineProps(["link", "text", "width", "height"]);

// Define a ref for link
const link = ref(props.link);

// Watch for changes in the link prop
watch(
  () => props.link,
  (newVal) => {
    if (newVal) {
      link.value = newVal;
    }
  },
  { immediate: true }
);
</script>
